module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/nf-7c3216dcabd2a393fa48df68238d1667.svg";